import { useEffect } from 'react';

// While a drawer or modal is mounted, mark <body> so responsive.css can stop the
// page behind it from scrolling (small screens only). Counted so overlapping
// overlays don't unlock each other.
let locks = 0;

export default function useBodyScrollLock() {
  useEffect(() => {
    locks += 1;
    document.body.classList.add('modal-open');
    return () => {
      locks = Math.max(0, locks - 1);
      if (locks === 0) document.body.classList.remove('modal-open');
    };
  }, []);
}
